jQuery(document).on('ready', function(){
	LFORM.onReady();
	
});



var LFORM= {
	onReady: function(){
		if(jQuery('.block-contact-form form').length < 1)
			return;

		jQuery(document).on('click', '.block-contact-form form #mnsk-submit', LFORM.initSubmit);
		// jQuery(document).on('submit', '.form-lead form', LFORM.initSubmit);
	},


	initSubmit: function(){
		// LFORM.context 		= this;
		LFORM.context 		= jQuery(this).closest('form');
		LFORM.formname 		= jQuery('input[name=mnsk-form-name]', LFORM.context).val();
		LFORM.action 		= jQuery('input[name=mnsk-action]', LFORM.context).val();

		LFORM.DEFvalidation = new jQuery.Deferred();

		LFORM.validateForm();



		jQuery.when(LFORM.DEFvalidation).then(function(){
			if(LFORM.error.length >= 1){
				LFORM.displayErrorMsg();
			} else {
				LFORM.sendForm();
			}
		});

		return false;
	},



	displayErrorMsg: function(){
		jQuery('.msg', LFORM.context ).remove();

		jQuery.each(LFORM.error, function(i,v){
			jQuery('.messages', LFORM.context).prepend('<p class="msg error">' + v + '</p>');
		});

		jQuery('html, body').animate({
		    scrollTop: jQuery(jQuery('.msg:first-of-type', LFORM.context)).offset().top - 110
		},'slow');
	},



	validateForm: function(){
		LFORM.error = [];
		
		jQuery.each(jQuery('input.required, select.required', LFORM.context), function(i,v){
			if (jQuery(v).prop('nodeName') == 'SELECT') {
				if(jQuery('option:selected', v).val() == false)
					LFORM.error.push(jQuery(v).data('errormsg'));

			} else if (jQuery(v).attr('type') == 'email') {
				var regex = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
				
				if(regex.test(jQuery(v).val()) == false || jQuery(v).val() == '')
					LFORM.error.push(jQuery(v).data('errormsg'));
				
			} else if (jQuery(v).attr('type') == 'checkbox'){				
				if(!jQuery(v).prop('checked'))
					LFORM.error.push(jQuery(v).data('errormsg'));

			} else if (jQuery(v).attr('type') == 'radio') {
				if(jQuery('[name="' + jQuery(v).attr('name') + '"]:checked').length == 0 && jQuery.inArray(jQuery(v).data('errormsg'), LFORM.error) == -1)
					LFORM.error.push(jQuery(v).data('errormsg'));
				
			} else if (jQuery(v).attr('type') == 'submit') {
				console.log('submit');
				
			} else {
				if(jQuery(v).val() == '')
					LFORM.error.push(jQuery(v).data('errormsg'));
			}
		});

		return LFORM.DEFvalidation.resolve();
	},



	sendForm: function(){
		var formData = jQuery(LFORM.context).serialize();

		jQuery.ajax({
		    type: 'POST',
		    url: mnskJS.ajaxurl,
		    data: 'action=' + LFORM.action + '&' + formData,
	        success: function (response, textStatus, XMLHttpRequest) {
	        	var regex    = new RegExp(/[0]$/);
				var response = jQuery.trim(response.replace(regex, ''));
				var resJson;
				var tpl = '';

				if(LFORM.action == 'submit-training-booking') { // IS Training
					tpl = jQuery('h2').clone().wrap('<div/>').parent().html();
					tpl += '<br />';
		            if(jQuery('input[name="azak-booking"]').prop('checked'))
		            	var ref = 'booking';
		            else if(jQuery('input[name="azak-waitlist"]').val() == 'true')
		            	var ref = 'waiting';
		            else
		            	var ref = 'reservation';
				}
				
				console.log(response);

				try {
					var resJson = jQuery.parseJSON( response );
				} catch(e) {
	            	jQuery(LFORM.context).after('<p class="msg error">Es ist ein unbekannter Fehler aufgetreten.</p>');
				}

				if (typeof resJson.error !== 'undefined' && resJson.error.length >= 1) {
					jQuery.each( resJson.error, function(i,v){
						tpl += '<p class="msg error">' + v + '</p>'; 
					});
				} 

				if (typeof resJson.success !== 'undefined' && resJson.success.length >= 1) {
					jQuery.each( resJson.success, function(i,v){
						tpl += '<p class="msg success">' + v + '</p>'; 
					});
				}


	            jQuery(LFORM.context).after(tpl);
	            jQuery(LFORM.context).remove();

	            // if(!resJson.error)
	            	setTimeout(function() {window.location.href = mnskJS.url + '/uebertragung-erfolgreich/azak/' + LFORM.formname + '/?post=' + azJS.postID + '&' + ref}, 1000);
	        },
	        error: function (XMLHttpRequest, textStatus, errorThrown) {
	            console.log('Server error: ' + errorThrown);
	        }
	    });
	}
}